import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

export const BlogEnglishNotice = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const isFrench = location.pathname.startsWith('/fr');

  if (!isFrench) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="bg-gradient-to-r from-oli-blue-light/20 to-oli-blue-light/10 border-2 border-oli-blue-light rounded-xl p-6 mb-8"
    >
      <div className="flex items-start gap-4">
        <span className="text-3xl">📝</span>
        <div>
          <h3 className="text-lg font-semibold text-oli-blue mb-2">
            {t('blogEnglishOnly.badge')}
          </h3>
          <p className="text-foreground">
            {t('blogEnglishOnly.description')}
          </p>
        </div>
      </div>
    </motion.div>
  );
};
